export default __webpack_public_path__ + "static/media/DefrostCycle.470caa78.svg";